import { BottomBarLayout } from './BottomBarLayout'
export default BottomBarLayout
